import MNumberKeyboard from './number-keyboard'

MNumberKeyboard.install = function (Vue) {
  Vue.component(MNumberKeyboard.name, MNumberKeyboard)
}

export default MNumberKeyboard



// WEBPACK FOOTER //
// ./src/m/number-keyboard/index.js